import axios from '../api/axios'

export default {
    versionList({params, callback}){
        axios.get(`/v1/admin/version/version-list/${params.type}/${params.pageNum}/${params.pageSize}`).then(res => {
            callback(res)
        }).catch(err => {
            callback(err)
        })
    },
    versionAdd({params, callback}){
        axios.post(`/v1/admin/version/version-add`, params).then(res => {
            callback(res)
        }).catch(err => {
            callback(err)
        })
    }
}


// WEBPACK FOOTER //
// ./src/api/setting.js